import { createSlice } from "@reduxjs/toolkit";

const initialState = {};
const UserActivityReducer = createSlice({
  name: "UserActivity",
  initialState,
  reducers: {
    defaultAction: (state, { payload }) => {
      console.log("UserActivityReducer state and payload", state, payload);
    },
  },
});

const { reducer, actions } = UserActivityReducer;
export const { defaultAction } = actions;
export default reducer;
